/**
 * Searches for the play buttons on top of an panel image
 * and add event listener for each found button to
 * play a given embedded video in a modal on click.
 */

const VideoPopup = () => {
  const videoModal = document.getElementById('video-modal');
  const iframe = document.getElementById('modal-iframe');
  if (!videoModal || !iframe) return;

  const videoModalButtons = document.querySelectorAll(
    '[data-video-modal-button]',
  );
  videoModalButtons.forEach((videoModalButton) => {
    const videoUrl = videoModalButton.getAttribute('data-url');
    const openModal = () => {
      iframe.src = videoUrl;
      videoModal.classList.remove('hidden');
    };

    const closeModal = () => {
      iframe.src = '';
      videoModal.classList.add('hidden');
    };

    videoModalButton.addEventListener('click', openModal);
    videoModal.addEventListener('click', (event) => {
      if (event.target === videoModal) {
        closeModal();
      }
    });
  });
};

export default VideoPopup();
